export default __webpack_public_path__ + "static/4-45674037c0a19e66b893560d9a241ea5.png";